import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/theme/tss-react';
import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isRightAligned?: boolean;
  isPlayButtonOnDark?: boolean;
  isOnDark: boolean | undefined;
  mobileOrientation?: 'Image first' | 'Text first';
}

const useStyles = makeStyles<Props, 'image'>({
  name: 'HighlightLightbox',
})(
  (
    { breakpoints, brandColors, spacing, aspectRatio, typography },
    props,
    classes
  ) => {
    return {
      container: {
        backgroundColor: darkOrLightStyle(props)(
          brandColors.tintsHeroBlue10,
          brandColors.offWhite
        ),
        paddingTop: spacing(3),
        paddingBottom: spacing(3),
      },
      content: {
        backgroundColor: darkOrLightStyle(props)(
          brandColors.tintsHeroBlue40,
          brandColors.tintsOffWhite80
        ),
        boxShadow: '0 0 16px 0 rgba(31, 38, 71, 0.08)',
        padding: spacing(2),
        width: '100%',
        borderRadius: spacing(1),
        alignItems: 'center',
        flexWrap: 'nowrap',
        flexDirection: props.isRightAligned ? 'row' : 'row-reverse',
        [breakpoints.down('md')]: {
          flexDirection: props.mobileOrientation
            ? props.mobileOrientation === 'Text first'
              ? 'column-reverse'
              : 'column'
            : props.isRightAligned
              ? 'column'
              : 'column-reverse',
        },
      },
      image: {
        width: '100%',
        height: '100%',
        display: 'block',
        aspectRatio: aspectRatio['16/9'],
        objectFit: 'cover',
        transition: 'transform 0.3s ease-in-out',
        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
        },
      },
      heading: {
        color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      },
      headingGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(-1),
      },
      subheading: {
        marginTop: spacing(0),

        color: darkOrLightStyle(props)(
          brandColors.tintsOffWhite40,
          brandColors.tintsNeutral20
        ),
      },
      cta: {
        marginTop: spacing(2),
        minWidth: '150px',

        [breakpoints.up('md')]: {
          marginTop: spacing(1),
        },
      },
      textContent: {
        width: '100%',
      },
      imageContent: {
        aspectRatio: aspectRatio['16/9'],
        display: 'block',
        borderRadius: pxToRem(16),
        cursor: 'pointer',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        background: 'transparent',
        border: 'none',
        margin: 0,
        padding: 0,
        '&:hover, &:focus-visible': {
          [`& .${classes.image}`]: {
            transform: 'scale(1.1)',
          },
        },
        '@media (prefers-reduced-motion: reduce)': {
          '&:hover, &:focus-visible': {
            [`& .${classes.image}`]: {
              transform: 'none',
            },
          },
        },
      },
      svgOverlay: {
        position: 'absolute',
        bottom: typography.pxToRem(16),
        left: typography.pxToRem(16),
        zIndex: 1,
        pointerEvents: 'none',

        [breakpoints.up('sm')]: {
          bottom: typography.pxToRem(24),
          left: typography.pxToRem(53),
        },
        [breakpoints.up('lg')]: {
          bottom: typography.pxToRem(34),
          left: typography.pxToRem(24),
        },
      },
      playIcon: {
        color: props.isPlayButtonOnDark ? 'black' : 'white',
      },
    };
  }
);

export default useStyles;
